import { OffCanvasLayout } from "@wac-ui-dashboard/wac_component_library";
import AudioBulkUpload from "../../Podcast/AudioBulkUpload";
import VideoBulkUpload from "../../MediaVideo/VideoBulkUpload";

/**
 * Bulk upload panel for the media listings. One entry is created per file, titled with
 * the file name: Podcast and News upload audio files, Video and Shorts upload video
 * files to Vimeo.
 */
const MODULES = {
  podcast: {
    title: "Bulk Upload Podcast Audio",
    kind: "audio",
    endpoint: "admin/podcast/bulk-upload/audio",
    label: "podcast",
  },
  news: {
    title: "Bulk Upload News Audio",
    kind: "audio",
    endpoint: "admin/news/bulk-upload/audio",
    label: "news item",
  },
  video: {
    title: "Bulk Upload Videos",
    kind: "video",
    endpoint: "admin/video/bulk-upload/videos",
    label: "video",
  },
  shorts: {
    title: "Bulk Upload Shorts",
    kind: "video",
    endpoint: "admin/short/bulk-upload/videos",
    label: "short",
    requireCategory: true, // the shorts collection needs a category on every record
  },
};

const MediaBulkUpload = ({ show, handleClose, module, refetch }) => {
  const config = MODULES[module];

  return (
    <OffCanvasLayout
      show={show}
      handleClose={handleClose}
      title={config?.title ?? "Bulk Upload"}
      closeIcon={<span className="material-symbols-outlined"> close </span>}
      backdrop={"static"}
    >
      {!show || !config ? (
        <p className="pro-font-sm pro-mb-0">
          Bulk upload for this section is not available yet.
        </p>
      ) : config.kind === "audio" ? (
        <AudioBulkUpload
          endpoint={config.endpoint}
          entityLabel={config.label}
          refetch={refetch}
          handleClose={handleClose}
        />
      ) : (
        <VideoBulkUpload
          endpoint={config.endpoint}
          entityLabel={config.label}
          requireCategory={config.requireCategory ?? false}
          refetch={refetch}
          handleClose={handleClose}
        />
      )}
    </OffCanvasLayout>
  );
};

export default MediaBulkUpload;
